import styled, { css } from 'styled-components'

import { helpers } from '../../../styles/theme'

type Props = {
	isChecked: boolean
	isDisabled: boolean
	isReadOnly: boolean
	isFocusVisible: boolean
	isHovered: boolean
	isDirty: boolean
	isSmall: boolean
}

export const ToggleComponent = styled.div<Props>`
	position: relative;
	border-radius: ${({ isSmall }) => (isSmall ? '14px' : '22px')};
	width: ${({ isSmall }) => (isSmall ? '26px' : '40px')};
	height: ${({ isSmall }) => (isSmall ? '14px' : '22px')};
	background-color: ${({ isChecked, isHovered, isDisabled, isReadOnly }) => {
		if (isHovered && !(isDisabled || isReadOnly))
			return isChecked ? helpers.color.input.toggleBackgroundCheckedHover : helpers.color.input.toggleBackgroundHover
		if (isDisabled) return helpers.color.input.toggleBackgroundDisabled
		if (isReadOnly)
			return isChecked
				? helpers.color.input.toggleBackgroundCheckedReadOnly
				: helpers.color.input.toggleBackgroundReadOnly
		return isChecked ? helpers.color.input.toggleBackgroundChecked : helpers.color.input.toggleBackground
	}};
	outline: 0;
	flex-shrink: 0;
	margin: auto;
	cursor: ${({ isDisabled, isReadOnly }) => (isDisabled || isReadOnly ? 'auto' : 'pointer')};

	transition: background-color 0.15s ease-in-out;

	&:before {
		position: absolute;
		content: '';
		height: ${({ isSmall }) => (isSmall ? 12 : 18)}px;
		width: ${({ isSmall }) => (isSmall ? 12 : 18)}px;
		left: ${({ isSmall }) => (isSmall ? 1 : 2)}px;
		bottom: ${({ isSmall }) => (isSmall ? 1 : 2)}px;
		background-color: ${({ isDisabled, isReadOnly }) => {
			if (isDisabled) return helpers.color.input.toggleDisabled
			if (isReadOnly) return helpers.color.input.toggleReadOnly
			return helpers.color.input.toggle
		}};
		transition: transform 0.15s;
		border-radius: 50px;
		transform: ${({ isChecked, isSmall }) => {
			if (isSmall) return isChecked ? 'translateX(12px)' : 'translateX(0)'
			return isChecked ? 'translateX(18px)' : 'translateX(0)'
		}};
	}

	&:after {
		position: absolute;
		content: '';
		height: 4px;
		width: 4px;
		left: ${({ isSmall }) => (isSmall ? 5 : 9)}px;
		bottom: ${({ isSmall }) => (isSmall ? 5 : 9)}px;
		background-color: ${({ isDirty }) => (isDirty ? helpers.color.input.changeIndicator : 'transparent')};
		transition: transform 0.15s, background-color 0.15s;
		border-radius: 50px;
		transform: ${({ isChecked, isSmall }) => {
			if (isSmall) return isChecked ? 'translateX(12px)' : 'translateX(0)'
			return isChecked ? 'translateX(18px)' : 'translateX(0)'
		}};
	}

	${({ isFocusVisible }) =>
		isFocusVisible &&
		css`
		outline: ${helpers.color.input.focusOutline} solid 2px;
		outline-offset: 2px;
	`}
`
